<template>
	<AppBottomSheet :active="active" @toggling-popup="toggleItemProductExplain" :force-width="bottomSheetWidth">
		<ModalHeader :title="getString('product_with_variations')" :button-text="getString('confirm')"
					 @click-button="toggleItemProductExplain(false)" />

		<div class="product-container" :class="{active: itemActive(item), 'no-variation': item.products.length === 0}" v-for="item in menuItems"
			 @click="increaseSelectedItemQuantity(item)">
			<div class="product-header">
				<div class="left-side">
					<div class="quantity-indicators">
						<div class="total-quantity">
							<span class="txt-product-multiplier">x{{item.quantity-item.redeemed}}</span>
						</div>
						<div class="selected-quantity">
							{{getSelectedQuantity(item)}}
						</div>
					</div>
					<p class="txt-product-name">{{item.name}} </p>
				</div>
				<div class="right-side">
					<p class="txt-product-multiplier">{{currencyStore.readableCurrencyValue(item.price)}}</p>
					<AppClickableIcon v-if="itemActive(item)" icon-name="iconBin" :autoSetActive="false" @click="event => decreaseSelectedItemQuantity(item, event)"/>
				</div>
			</div>
			<div class="product-variations">
				<div class="variation" v-for="itemProduct in item.products">
					<p class="txt-product-name"><span class="txt-product-multiplier">x{{itemProduct.quantity}}</span> {{itemProduct.product_name}}</p>
					<p class="txt-product-multiplier">{{currencyStore.readableCurrencyValue(itemProduct.price)}}</p>
				</div>
			</div>
		</div>
	</AppBottomSheet>
</template>

<script>
import {useCurrencyStore, useLanguageStore} from "@/shared/stores";

import AppBottomSheet from "@/shared/components/AppBottomSheet.vue";
import ModalHeader from "@/console-new/components/shared/ModalHeader.vue";
import AppClickableIcon from "@/shared/components/AppClickableIcon.vue";
import WindowWidth from "@/console-new/mixins/WindowWidth";

export default {
	setup() {
		let languageStore = useLanguageStore();
		const currencyStore = useCurrencyStore();
		return {getString: languageStore.getString, currencyStore};
	},
	mixins: [WindowWidth],
	emits: ['toggle-close', 'increase-selected', 'decrease-selected'],
	props: {
		items: {
			type: Array,
			required: true,
		},
		menuItemId: {
			type: Number,
			require: true
		},
		selectedItems: {
			type: Array,
			required: true
		},
		active: {
			type: Boolean,
			required: true
		}
	},
	name: "ItemProductsExplain",
	components: {
		AppClickableIcon,
		ModalHeader,
		AppBottomSheet,
	},
	computed: {
		menuItems() {
			return (this.items || []).filter(item => {
				return item.menu_item_id === this.menuItemId && item.redeemed < item.quantity
			});
		},
		bottomSheetWidth() {
			if(this.windowWidth < 550) {
				return "100%";
			} else if(this.windowWidth < 768) {
				return "550px";
			} else {
				return "720px";
			}
		},
	},
	methods: {
		itemActive(item) {
			let selectedItem = this.getItemSelected(item);
			return selectedItem && selectedItem.selected > 0;
		},
		getItemSelected(item) {
			return this.selectedItems.find(i => i.id === item.id);
		},
		getSelectedQuantity(currItem) {
			let selItem = this.getItemSelected(currItem);
			return selItem ? `x${selItem.selected}` : 'x0';
		},
		increaseSelectedItemQuantity(item) {
			this.$emit('increase-selected', item);
		},
		decreaseSelectedItemQuantity(item, event) {
			event.stopPropagation();
			this.$emit('decrease-selected', item);
		},
		toggleItemProductExplain(active) {
			if(!active) {
				this.$emit('toggle-close', active);
			}
		},
	},
}
</script>

<style scoped lang="scss">

.product-container {
	display: flex;
	padding: 0 10px 10px 8px;
	flex-direction: column;
	justify-content: center;
	align-items: flex-start;
	align-self: stretch;
	border-radius: 13px;
	background: var(--color-alpha-1);
    border: 1px solid var(--color-primary);
	cursor: pointer;

	&.no-variation {
		padding-bottom: 0;
	}

    &.active {
		background: var(--color-display-alpha-green);
        border: 1px solid var(--color-secondary);
	}

	&:not(:last-child) {
		margin-bottom: 10px;
	}

	.txt-product-name {
		color: var(txt-primary);
		font-size: 14px;
		font-style: normal;
		font-weight: 500;
		line-height: normal;
	}
	.txt-product-multiplier {
		color: var(--color-primary);
		text-align: right;
		font-size: 13px;
		font-style: normal;
		font-weight: 600;
		line-height: normal;
	}

	.product-header {
		display: flex;
		padding: 10px 0;
		justify-content: space-between;
		align-items: center;
		align-self: stretch;

		.txt-product-name {
			padding-left: 10px;
		}
		.txt-product-multiplier:nth-child(2) {
			padding-right: 10px;
		}

		.left-side {
			display: flex;
			flex-direction: row;
			align-items: center;
		}
		.right-side {
			display: flex;
			flex-direction: row;
			align-items: center;
			gap: 10px;
		}

		.quantity-indicators {
			display: flex;
			flex-direction: row;
			align-items: center;

			.total-quantity {
				padding-left: 10px;
			}
			.selected-quantity {
				display: flex;
				justify-content: center;
				align-items: center;
				margin-left: 10px;
				border-radius: 10px;
				background: var(--color-alpha-1);
				box-shadow: 0 1px 5px 0 var(--color-alpha-2) inset;
				width: 50px;
				height: 24px;
			}
		}
	}

	.product-variations {
		display: flex;
		flex-direction: column;
		align-self: stretch;
		border-radius: 13px;
		background: var(--color-alpha-1);

		.variation {
			position: relative;
			display: flex;
			width: 100%;
			height: 45px;
			padding: 0 10px;
			justify-content: space-between;
			align-items: center;
			flex-shrink: 0;

			&:not(:last-child)::after {
				@include pseudo;
				position: absolute;
				bottom: 0;
				left: 0;
				height: 1px;
				width: 100%;
				background-color: var(--color-border-alpha);
			}
		}
	}
}


</style>